import Link from 'next/link'
import React from 'react'

function InnovationGrowth() {
   return (
      <section className="container-fluid section_secondary_bg">
         <div className="container text-center mb-5 innovation_comman">
            <h2 className="tech_title section_heading_title mb-2">
               Industry-Focused Innovation for Growth
            </h2>
            <p className="sub_body">
               We move business change into action through bespoke,
               technology-enhanced solutions crafted to increase efficiency,
               accelerate growth, and extract maximum
               <br />
               profitability. Our innovations enable firms to simplify business
               operations, lower costs, and open up new avenues for long-term
               success.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main">
               <div className="row g-4 industry-grid invo-ind-grid">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/health-fitness-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Health & Fitness</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Health.svg"
                                 alt="Health Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Smart Healthcare & Wellness
                           </h4>
                           <p className="industry-description">
                              Enhance patient care with digital health
                              monitoring, data-driven diagnostics, and efficient
                              medical record management. Our solutions improve
                              decision-making, streamline workflows, and support
                              better health outcomes.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/fintech-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Fintech</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Fintech.svg"
                                 alt="Fintech Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Smarter Financial Solutions
                           </h4>
                           <p className="industry-description">
                              Transform financial services with secure online
                              transactions, fraud protection, and real-time data
                              analysis. Our solutions enable businesses to
                              enhance risk management, maximize customer
                              experiences, and remain ahead in a competitive
                              marketplace.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/restaurant-hospitality-software-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Restaurant & Hospitality
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Food.svg"
                                 alt="Restaurant Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Enhanced Guest Engagement
                           </h4>
                           <p className="industry-description">
                              Enhance customer experiences with streamlined
                              reservations, demand planning, and tailored
                              services. Our solutions assist restaurants and
                              hotels with improved operations, cost savings, and
                              high-quality hospitality.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/e-commerce-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Ecommerce</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Ecommerce.svg"
                                 alt="Ecommerce Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Optimized Shopping Experiences
                           </h4>
                           <p className="industry-description">
                              Drive more sales with personalized
                              recommendations, real-time pricing, and automatic
                              stock management. Our solutions boost customer
                              interaction, enhance order execution, and simplify
                              operations for enhanced profitability.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/supply-chain-logistics-software-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Supply Chain & Logistics
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Supply.svg"
                                 alt="Logistics Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Efficient Operations & Tracking
                           </h4>
                           <p className="industry-description">
                              Streamline supply chains through predictive demand
                              planning, live tracking, and automated stock
                              management. Our solutions drive cost savings,
                              increase logistics efficiency, and ensure seamless
                              operations in various industries.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/social-dating-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Social & Dating</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Social.svg"
                                 alt="Social Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Personalized Connections
                           </h4>
                           <p className="industry-description">
                              Enhance social and dating platforms with
                              behavior-based recommendations, user engagement
                              tools, and smart content delivery. Our solutions
                              improve interaction quality, reduce churn, and
                              foster meaningful connections.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/gaming-sports-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Gaming & Sports</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Gaming.svg"
                                 alt="Social Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Performance & Engagement Tools
                           </h4>
                           <p className="industry-description">
                              Elevate gaming and sports with real-time
                              analytics, interactive experiences, and
                              performance optimization. Our solutions help
                              teams, players, and developers enhance engagement
                              and improve strategies.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/travel-tourism-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Travel & Tourism</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/travel.svg"
                                 alt="Gaming Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Seamless Travel Management
                           </h4>
                           <p className="industry-description">
                              Revolutionize the travel experience with automated
                              reservation systems, intelligent itinerary
                              management, and customer engagement solutions. Our
                              solutions assist travel companies in maximizing
                              pricing, customer satisfaction, and operational
                              efficiency.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/real-estate-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Real Estate</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Real-Estate.svg"
                                 alt="Travel Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Data-Driven Property Insights
                           </h4>
                           <p className="industry-description">
                              Maximize real estate success with market trend
                              analysis, automated pricing strategies, and smart
                              property management tools. Our solutions help
                              agents and investors make informed decisions and
                              close deals faster.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/education-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Education</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Edu.svg"
                                 alt="Real Estate Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Modern Learning Solutions
                           </h4>
                           <p className="industry-description">
                              Transform education with tailored learning
                              experiences, AI-driven assessments, and
                              intelligent content delivery. Our solutions boost
                              student engagement, accessibility, and improved
                              academic results.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/media-entertainment-software-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Media & Entertainment
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Media.svg"
                                 alt="Education Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Content & Audience Growth
                           </h4>
                           <p className="industry-description">
                              Streamline content creation with automated video
                              editing, audience insights, and smart
                              recommendations. Our solutions help media
                              companies boost engagement, optimize distribution,
                              and maximize reach.
                           </p>
                        </div>
                     </Link>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/government-public-sector-software-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Government & Public Sector
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Gov.svg"
                                 alt="Media Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              Smarter Governance & Services
                           </h4>
                           <p className="industry-description">
                              Enhance public services through effective resource
                              utilization, secure digital services, and
                              Industry-Leading Software Solutionsevidence-based
                              decision-making. Our solutions improve
                              Industry-Leading Software Solutionstransparency,
                              operational efficiency, and citizen participation.
                           </p>
                        </div>
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default InnovationGrowth
